
import Vue from "vue";
import {storeData} from "~/assets/api/kteApi";
import LoginNotice from "~/assets/components/gui/auth/LoginNotice.vue";
import {clearPersistedStateCache, markPersistedSessionStarted} from "~/assets/utils/PersistedSession";

export default Vue.extend({
	name: 'loginform',
  components: {LoginNotice},
	data: () => ({
		login: {
			username: null,
			password: null
		},
		message: null
	}),
	methods: {
		async userLogin() {
			try {
				const enabledSections = process.env.LINE_OF_BUSINESS.split(',').map(s => s.trim()).filter(Boolean);
				const firstSection = enabledSections[0];
				const defaultDash = `/${firstSection}/${firstSection}_dash`;

				await this.$auth.loginWith('local', {
					data: this.login
				}).then(async () => {
					this.$store.dispatch('RESET_STATE')
					clearPersistedStateCache()
					markPersistedSessionStarted()
					/**
					 * @author @Simo mailto:simoneolivieri@kubepartners.com
					 * @description //store filters
					 * @date 10:31 18/04/23
					 * @param storeData
					 * @return SET_FILTERS
					 **/
					await storeData(this.$store.commit, process.env.BASE_URL + '/api/filters', this.$auth.$state.token_local, 'SET_FILTERS').then(() => {
						console.log('filter stored')
					})
				}).then(async () => {
					if (enabledSections.includes('motor')) {
						await storeData(this.$store.commit, process.env.BASE_URL + '/api/motor/presets', this.$auth.$state.token_local, 'SET_PRESETS_MOTOR').then(() => {
							console.log('[Login] presets motor stored, store value:', JSON.stringify(this.$store.state.presets_motor).substring(0, 200))
							this.$store.commit('LOADED', true)
						})
					}
				}).then(async () => {
					if (enabledSections.includes('home')) {
						console.log('[Login] calling /api/home/presets with token:', this.$auth.$state.token_local ? 'present' : 'MISSING')
						await storeData(this.$store.commit, process.env.BASE_URL + '/api/home/presets', this.$auth.$state.token_local, 'SET_PRESETS_HOME').then(() => {
							console.log('[Login] presets home stored, store value:', JSON.stringify(this.$store.state.presets_home).substring(0, 200))
							setTimeout(() => {
								this.$store.commit('LOADED', true)
							}, 1000)
						})
					}
				})

				if (!enabledSections.includes('motor') && !enabledSections.includes('home')) {
					this.$store.commit('LOADED', true)
				}

				this.$auth.$storage.setUniversal('redirect', null)
				if (this.$router.currentRoute.path !== defaultDash) {
					this.$router.replace(defaultDash)
				}
			} catch (err) {
				this.message = this.$t('login.bad_request')
				console.log(err)
			}
		}
	}
})
